import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=1f8d70e8&scoped=true&"
import script from "./Sku.vue?vue&type=script&lang=js&"
export * from "./Sku.vue?vue&type=script&lang=js&"
import style0 from "./Sku.vue?vue&type=style&index=0&id=1f8d70e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d70e8",
  null
  
)

export default component.exports